export default "<app-load *ngIf=\"loadService.loader\"></app-load>\n<router-outlet *ngIf=\"!loadService.loader\"></router-outlet>"